import { withNamespaces } from "react-i18next";
import { Card, CardBody, CardHeader, Input, InputGroup, Label, UncontrolledTooltip } from "reactstrap";

const TraceApiKeyCard = ({ t, apiKey }) => {
    return (
        <Card className="mb-3 shadow-sm">
            <CardHeader>
                {t('Trace API Settings')}
            </CardHeader>
            <CardBody>
                <Label>
                    {t('API Key')}
                    <span
                        id="api-key-help-text"
                    >
                        <i
                            className="ri-information-line text-secondary"
                            aria-hidden="true"
                        />
                    </span>
                </Label>
                <InputGroup>
                    <Input
                        type="text"
                        value={apiKey}
                        readOnly
                        className="font-monospace"
                    />
                </InputGroup>
                <UncontrolledTooltip
                    placement="top"
                    target="api-key-help-text"
                >
                    {t('This API key is used to securely submit DDS data. Keep it confidential and do not share it.')}
                </UncontrolledTooltip>
            </CardBody>
        </Card>
    );
}


export default withNamespaces()(
    TraceApiKeyCard
);